/**
 * easy high resolution time measurement;
 * measures with the monotonic performance.now() clock, so values carry fractions of a millisecond
 */
export class HrtMeasurement {
  /**
   * the measured duration in nanoseconds, null until stop()
   */
  public nanoSeconds: number | null = null;
  /**
   * the measured duration in milliseconds (fractional), null until stop()
   */
  public milliSeconds: number | null = null;
  private _milliStart: number | null = null;
  private _milliDiff: number | null = null;

  /**
   * start the measurement
   */
  public start() {
    this._milliStart = performance.now();
  }

  /**
   * stop the measurement
   */
  public stop() {
    if (this._milliStart === null) {
      console.log("Hasn't started yet");
      return this;
    }
    this._milliDiff = performance.now() - this._milliStart;
    this.nanoSeconds = this._milliDiff * 1_000_000;
    this.milliSeconds = this._milliDiff;
    return this;
  }

  /**
   * reset the measurement
   */
  public reset() {
    this.nanoSeconds = null;
    this.milliSeconds = null;
    this._milliStart = null;
    this._milliDiff = null;
  }
}
